/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_3_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_3_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose online or desktop`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_3_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择在线版还是桌面版`)
};

/**
* | output |
* | --- |
* | "Choose online or desktop" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_3_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_3_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_3_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_3_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_3_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_3_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_3_title as "gc.search_guides.what_is_gridcraft.sections.3.title" }